import { Field, Input, makeStyles } from "@fluentui/react-components";
import { t } from "i18next";
type FieldInputProps = {
  name: string;
  label: string;
  type: string;
  inputId: string;
  inputSizeId: string;
  register: any;
  required: boolean;
  errors: any;
  watch?: any;
};
const useStyles = makeStyles({
  fieldWrapper: {
    minWidth: "300px",
  },

  input: {},
});
export const FieldInput = ({
  name,
  label,
  type,
  inputId,
  inputSizeId,
  required,
  register,
  errors,
  watch,
}: FieldInputProps) => {
  const styles = useStyles();
  const registerProps = register(name, {
    required: required,
    ...(name === "password" && {
      minLength: {
        value: 6,
        message: t("labels.passwordLength"),
      },
    }),
    ...(name === "confirmedPassword" && {
      validate: (value: string) =>
        value === watch("password") || t("error.passwordMatch"),
    }),
  });
  return (
    <div className={styles.fieldWrapper}>
      <Field
        size="medium"
        label={label}
        validationState={errors ? "error" : null}
        validationMessage={errors?.message}
        required={required}
      >
        <Input
          {...registerProps}
          required={required}
          appearance="underline"
          type={type}
          size="small"
          id={`${inputId} ${inputSizeId}`}
        />
      </Field>
    </div>
  );
};
